import Stack from '@/design_system/Stack';
import { Workflow } from '@/models/workflow';

import { Stores } from './components/Stores';
import { StoreTypes } from './components/StoreTypes';
import { Type } from './components/Type';

export const ScopeSection = ({ workflow }: { workflow: Workflow }) => {
  return (
    <Stack gap="1rem">
      <Type workflow={workflow} />
      {(workflow.type === 'store' || workflow.type === 'client_via_store') && (
        <>
          <StoreTypes workflow={workflow} />
          <Stores workflow={workflow} />
        </>
      )}
    </Stack>
  );
};
